import { render, staticRenderFns } from "./PlansEquipmentDeviceSummaryTable.vue?vue&type=template&id=a9c80c20&scoped=true&"
import script from "./PlansEquipmentDeviceSummaryTable.vue?vue&type=script&lang=js&"
export * from "./PlansEquipmentDeviceSummaryTable.vue?vue&type=script&lang=js&"
import style0 from "./PlansEquipmentDeviceSummaryTable.vue?vue&type=style&index=0&id=a9c80c20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c80c20",
  null
  
)

export default component.exports